/**
 * Retrieves the value of the 'utm_source' query parameter from the current URL.
 * If the parameter is not present, returns null.
 *
 * @returns {string | null} The value of the 'utm_source' parameter or null if not found.
 */
export const getUtmSource = (): string | null => {
    if (!window?.location?.search) {
        return null;
    }
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('utm_source');
};

/**
 * Removes the 'utm_source' query parameter from the current URL without reloading the page.
 */
export const removeUtmSourceFromUrl = (): void => {
    if (!window?.history?.replaceState || !window?.location) {
        return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('utm_source')) {
        return;
    }
    urlParams.delete('utm_source');
    const newRelativePathQuery =
        window.location.pathname +
        (urlParams.toString() ? `?${urlParams.toString()}` : '') +
        window.location.hash;
    window.history.replaceState(null, '', newRelativePathQuery);
};
